import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { Container, Link } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import logo from "bb-logo.png";

const useStyles = makeStyles(theme => ({
  sideBar: {
    width: 100,
    height: "100%",
    top: 0,
    bottom: 0,
    background: "#0D5876 0% 0% no-repeat padding-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  icon: {
    color: theme.palette.secondary.contrastText,
  },

  logo: {
    position: "relative",
    width: 50,
    top: 30,
  },

  supportLink: {
    textAlign: "center",
    marginBottom: theme.spacing(2),
    color: "white",
  },
}));

const ReportsSideBar = () => {
  const classes = useStyles();

  return (
    <Container className={classes.sideBar} role="complementary">
      <Link href="https://library.biblioboard.com" target="_blank">
        <img className={classes.logo} src={logo} alt="BiblioBoard Logo" />
      </Link>

      <div className={classes.supportLink}>
        <Link
          underline="none"
          color="textSecondary"
          href="mailto:support@biblioboard.com"
        >
          <HelpIcon className={classes.icon} />
          <Typography color="textSecondary">Support</Typography>
        </Link>
      </div>
    </Container>
  );
};

export default ReportsSideBar;
